{
  "version": 1,
  "asset_id": "09770e5a-b8c7-4470-ad2b-ca40da08a63e",
  "project_id": "8f4e0cb3-546d-4528-9687-8899f14664d6",
  "url": "/__l5e/assets-v1/09770e5a-b8c7-4470-ad2b-ca40da08a63e/ia-suelos-hormigon-madrid.png",
  "r2_key": "a/v1/8f4e0cb3-546d-4528-9687-8899f14664d6/09770e5a-b8c7-4470-ad2b-ca40da08a63e/ia-suelos-hormigon-madrid.png",
  "original_filename": "ia-suelos-hormigon-madrid.png",
  "size": 85093,
  "content_type": "image/png",
  "created_at": "2026-11-05T15:14:31Z"
}
